import React from 'react';
import { Icon, IconName } from 'components/Icon/Icon';
import Text from 'components/Text/Text';

export const NoDataNew: React.FC = () => (
	<div className="p-8 rounded flex flex-col items-center gap-1 bg-purple-01-new" data-test="NoData">
		<Icon className="text-purple-03-new" name={IconName.empty} size="xxl" />
		<Text translationNameSpace="form" translationKey="noData" theme="neutralLight" size="xs" />
	</div>
);
